import React, { useEffect, Component, Fragment, useState } from "react";

import "./../css/VUP_dash.css";

export const EngBarChart = (props) => {
  // const { engUnitVal } = props;
  const { engUnitValCons, engUnitValProd } = props;
  const consInstVal = isNaN(props.consInstVal)? undefined : parseInt(props.consInstVal);
  const prodInstVal = isNaN(props.prodInstVal)? undefined : parseInt(props.prodInstVal);
  // 기준값  : prod와 cons 중 더 큰 값의 1.2배
  const refVal =
    isNaN(consInstVal) ||
      isNaN(prodInstVal) ||
      consInstVal === undefined ||
      prodInstVal === undefined ? 0
      : consInstVal !== prodInstVal && consInstVal > prodInstVal ? consInstVal * 1.2
        : prodInstVal * 1.2;
  const consPer =
    isNaN(consInstVal) || isNaN(refVal) || refVal === 0 ? 0
      : (consInstVal / refVal) * 100;
  const prodPer =
    isNaN(prodInstVal) || isNaN(refVal) || refVal === 0 ? 0
      : (prodInstVal / refVal) * 100;

  return (
    <>
      <table className="chartBar">
        <tbody>
          <tr>
            <td>
              {isNaN(prodInstVal) ? null : <><span style={{ color: "#2ba8a2" }}>●</span> 공급</>}
              {isNaN(consInstVal) ? null : <><span style={{ color: "#81d973" }}>●</span> 수요</>}
            </td>
            <td>
              {isNaN(prodInstVal)&&isNaN(consInstVal) ? "" :
              <div className="chartBoxGroup">
                <div className="chartBox">
                  {isNaN(prodInstVal) ? "" :
                    <><div
                      className="progress-bar"
                      style={{
                        background: `linear-gradient(to right, #2ba8a2 0 ${prodPer}%, #333 ${prodPer}% 100%)`,
                      }}
                    ></div><div className="dataLine">
                        {prodInstVal.toLocaleString('ko-KR')}
                        <span className="unit">
                          {engUnitValProd}
                        </span>
                      </div></>}
                </div>
                <div className="chartBox">
                  {isNaN(consInstVal) ? "" :
                    <><div
                      className="progress-bar"
                      style={{
                        background: `linear-gradient(to right, #81d973 0 ${consPer}%, #333 ${consPer}% 100%)`,
                      }}
                    ></div>
                      <div className="dataLine">
                        {consInstVal}
                        <span className="unit">
                          {engUnitValCons}
                        </span>
                      </div></>}
                </div>
              </div>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};
